import {
  CREATE_WEEKLY_INTERNATIONAL_POWER_METER_REPORT,
  DELETE_WEEKLY_INTERNATIONAL_POWER_METER_REPORT,
  EDIT_WEEKLY_INTERNATIONAL_POWER_METER_REPORT,
  RECEIVE_WEEKLY_INTERNATIONAL_POWER_METER_REPORTS,
  REQUEST_WEEKLY_INTERNATIONAL_POWER_METER_REPORT,
  REQUEST_WEEKLY_INTERNATIONAL_POWER_METER_REPORTS_FOR_SITE_WITH_RANGE,
} from '@sophocles/entities/WeeklyInternationalPowerMeterReport/weeklyInternationalPowerMeterReportActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_WEEKLY_INTERNATIONAL_POWER_METER_REPORTS: // Read
      return state.merge(action.weeklyInternationalPowerMeterReports);
    case DELETE_WEEKLY_INTERNATIONAL_POWER_METER_REPORT: // Delete
      return state.delete(action.weeklyInternationalPowerMeterReport.toString());
    case EDIT_WEEKLY_INTERNATIONAL_POWER_METER_REPORT: // Update
    case CREATE_WEEKLY_INTERNATIONAL_POWER_METER_REPORT: // Create
    case REQUEST_WEEKLY_INTERNATIONAL_POWER_METER_REPORT:
    case REQUEST_WEEKLY_INTERNATIONAL_POWER_METER_REPORTS_FOR_SITE_WITH_RANGE:
    default:
      return state;
  }
}

export function weeklyInternationalPowerMeterReportReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_WEEKLY_INTERNATIONAL_POWER_METER_REPORT:
    case DELETE_WEEKLY_INTERNATIONAL_POWER_METER_REPORT:
    case RECEIVE_WEEKLY_INTERNATIONAL_POWER_METER_REPORTS:
    case EDIT_WEEKLY_INTERNATIONAL_POWER_METER_REPORT:
    case REQUEST_WEEKLY_INTERNATIONAL_POWER_METER_REPORT:
    case REQUEST_WEEKLY_INTERNATIONAL_POWER_METER_REPORTS_FOR_SITE_WITH_RANGE:
      return getState(state, action);
    default:
      return state;
  }
}
